import Buefy from '@ntohq/buefy-next'
import { BuefyFeather } from '@/components/icons/BuefyFeatherIcon'
import type { App } from 'vue'

export default function (app: App) {
  // @ts-ignore
  app.use(Buefy, {
    defaultIconPack: 'feather',
    defaultIconComponent: BuefyFeather,
    defaultIconPrev: 'arrow-left',
    defaultIconNext: 'arrow-right',
    customIconPacks: {
      feather: {
        iconPrefix: '',
        sizes: {
          default: '24px',
          'is-small': '18px',
          'is-medium': '36px',
          'is-large': '48px'
        }
      }
    }
  })
}
